// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f3f3b27b5884a2b6f4bb56d217c78f38369d142d/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};